import { darkenColor } from '../../utils/helpers';
import { RootReducerState } from '../../store/reducer';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

export interface ButtonProps
  extends React.DetailedHTMLProps<
      React.ButtonHTMLAttributes<HTMLButtonElement>,
      HTMLButtonElement
    >,
    React.AriaAttributes {}

const Button: React.FC<ButtonProps> = (props) => {
  const { children, type, className, ...rest } = props;
  let branchColour = useSelector(
    (state: RootReducerState) => state.dashboard.selectedBranch.branch_colour
  );
  if (!branchColour) {
    branchColour = '#31E2C4';
  }

  const submit = `rounded px-8 py-2 text-sm text-white transition duration-150 ease-in-out focus:outline-none`;
  const cancel = `ml-3 rounded border bg-gray-100 px-8 py-2 text-sm text-gray-600 transition duration-150 ease-in-out hover:border-gray-400 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2`;
  const base = `ml-3 rounded border px-8 py-2 text-sm transition duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2`;

  const classType = useMemo(() => {
    switch (type) {
      case 'submit':
        return submit;
      case 'button':
        return base;
      default:
        return cancel;
    }
  }, [type]);

  const inlineStyles = useMemo(() => {
    if (type === 'submit') {
      return {
        backgroundColor: branchColour,
        transition: 'background-color 0.3s, box-shadow 0.3s',
      };
    }
    return {};
  }, [branchColour, type]);

  const handleMouseEnter = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (type === 'submit') {
      (e.currentTarget as HTMLButtonElement).style.backgroundColor =
        darkenColor(branchColour, 20);
    }
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (type === 'submit') {
      (e.currentTarget as HTMLButtonElement).style.backgroundColor =
        branchColour;
    }
  };

  const handleFocus = (e: React.FocusEvent<HTMLButtonElement>) => {
    if (type === 'submit') {
      (
        e.currentTarget as HTMLButtonElement
      ).style.boxShadow = `0 0 0 3px ${branchColour}`;
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLButtonElement>) => {
    if (type === 'submit') {
      (e.currentTarget as HTMLButtonElement).style.boxShadow = 'none';
    }
  };

  return (
    <button
      className={`${classType} ${className}`}
      style={inlineStyles}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleFocus}
      onBlur={handleBlur}
      type={type}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
